import {__HERMES__, __MYPARTNER__} from './../../../config/api-config';
import {parseDateIntoHermesString} from '../../../utils/date-utils';

export function prepareDetailsPageHermesCall(
  config,
  // cityId = '',
  // vhid,
  // retry = true,
  // sendGAData = false,
) {
  const {
    vhid,
    cityId,
    checkin,
    checkout,
    roomString,
    pricingData,
    staticData,
    selectedHotelStatic,
    searchQuery,
    channel,
    pc = '',
    filter,
    offerCodeFromQueryParam,
  } = config;
  if (!vhid || !cityId) {
    return '';
  }

  const hotelId = vhid;
  const {ibp = '', hmd = ''} = selectedHotelStatic;
  const {hctx = '', sctx = ''} = filter;
  const context = hctx ? `&hctx=${hctx}` : '';
  const subContext = sctx && sctx.length ? `&sctx=${sctx}` : '';
  const offerCode = offerCodeFromQueryParam ? `&pc=${offerCodeFromQueryParam}` : '';
  const targetPricingData = pricingData ? pricingData[hotelId] : {};
  const {updatedAt, loaded} = targetPricingData;
  // check if data from SRP is there, else take the store pc value
  // const pc = selectedHotelStatic && Object.keys(selectedHotelStatic).length ? selectedHotelStatic.pc : hotels.pc;

  let vcid = cityId;
  if (!vcid && searchQuery !== null && searchQuery.ct && searchQuery.ct._id) {
    vcid = searchQuery.ct._id;
  } else if (
    !vcid &&
    staticData &&
    staticData[hotelId] &&
    staticData[hotelId].data &&
    staticData[hotelId].data.vcid
  ) {
    vcid = staticData[hotelId].data.vcid;
  }

  const obj = {};
  obj[hotelId] = {
    loaded: false,
  };
  if (updatedAt && loaded && new Date(updatedAt) > new Date() - 10 * 60 * 1000) {
    obj[hotelId] = targetPricingData;
  }
  // const authId = user.header['OAUTH-GOIBIBO'] || '';
  const ci = parseDateIntoHermesString(checkin.date);
  const co = parseDateIntoHermesString(checkout.date);
  const isHmd = hmd ? `&hmd=${hmd}` : '';
  // const filteredPaymodes = [1];
  // const pmFilter = filteredPaymodes ? `&pm=${filteredPaymodes}` : '';
  const pricingVersion = `/api/v12/detail/price/v3`;
  // const pricingVersion = `/hotels/v12/detail/price/v3`;

  const hermesUrl = `${__MYPARTNER__}${pricingVersion}/${vcid}/${ci}/${co}/${roomString}/${hotelId}?${
    ibp ? `&ibp=${ibp}` : ''
  }&tmz=${checkin.date.getTimezoneOffset()}${context}${subContext}${
    channel ? `&tags=["${channel}"]` : ''
  }${isHmd}${offerCode}`;
  // const hermesUrl = `${__HERMES__}${pricingVersion}/${vcid}/${ci}/${co}/${roomString}/${hotelId}?${
  //   ibp ? `&ibp=${ibp}` : ''
  // }&tmz=${checkin.date.getTimezoneOffset()}${context}${subContext}${
  //   channel ? `&tags=["${channel}"]` : ''
  // }${isHmd}${offerCode}`;
  return hermesUrl;
}
